import { Typography } from "antd"
import Select from 'react-select'
import React, { useState } from 'react'

import { usePet } from '../../modules'

import Modal from "../resusable/modal"
import Confirm from "../resusable/confirm"
// import Amenities from './amenities'

const { Paragraph } = Typography

const NewTable = ({ toggle, visible, onComplete }) => {
    const [name, setName] = useState()
    const [capacity, setCapacity] = useState(4)

    const [{ loading }, execute] = usePet('newTable', {
        name,
        capacity
    }, { notify: true, hasFile: true, callback: (_, notif, ops) => {
        notif('Table has been added', ops('success'))
        onComplete()
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Adding new table...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/2 lg:w-1/3 xl:w-1/4"
            title="New Table"
            toggle={toggle}
            visible={visible}>
            <div className="w-full bg-white">
                <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Table Name
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={ e => setName(e.target.value) }
                            placeholder="Table X" />
                    </div>
                </div>  
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Table Capacity
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-capacity"
                            type="text"
                            name="capacity"
                            value={capacity}
                            onChange={ e => setCapacity(e.target.value) }
                            placeholder="XX" />
                    </div>
                </div> 
            </div>
            <div className="flex justify-end">
                <button onClick={ () => Confirm({
                    title: 'Save Changes?',
                    desc: 'Are you sure you want to save these changes?',
                    okText: 'Save Changes',
                    onOk: execute
                }) } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default NewTable